import { render, staticRenderFns } from "./card-user.vue?vue&type=template&id=219e7a96&"
import script from "./card-user.vue?vue&type=script&lang=js&"
export * from "./card-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports